setTimeout(function() {
    document.querySelectorAll('.axt_show_original').forEach(element => {
        // Find the closest second parent <div>
        const secondParentDiv = element.closest('div');
        if (secondParentDiv && !secondParentDiv.nextElementSibling?.textContent.includes('including GST')) {

          // Create a new span element
            const spanAxt = document.createElement('span');
            spanAxt.textContent = 'including GST';
            spanAxt.style.fontSize = '21px';
            spanAxt.style.whiteSpace = 'nowrap';
            spanAxt.style.marginTop = '-19px';
            spanAxt.style.marginBottom = '5px';
            spanAxt.style.display = 'block';
          
            console.log(spanAxt);
          
            secondParentDiv.insertAdjacentElement('afterend', spanAxt);
        }
    });
}, 4000);
